var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActiveYourResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8309 11.902L6.75 5.75L12.1696 10.0296C12.9401 10.638 12.9441 11.7972 12.1777 12.4107C11.4114 13.0243 10.2689 12.7766 9.8309 11.902Z",
    stroke: "url(#paint0_linear_9663_4577)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 3.56986C1.89864 5.38888 0.75 7.92371 0.75 10.7275C0.75 16.2628 5.22715 20.75 10.75 20.75C16.2728 20.75 20.75 16.2628 20.75 10.7275C20.75 5.87406 17.3081 1.82642 12.7372 0.902737C11.9012 0.733797 11.4832 0.649327 11.1166 0.950077C10.75 1.25083 10.75 1.737 10.75 2.70935V3.71161",
    stroke: "url(#paint1_linear_9663_4577)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9663_4577",
    x1: 8.2388,
    y1: 6.17013,
    x2: 11.9392,
    y2: 11.6638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9663_4577",
    x1: 5.71266,
    y1: 1.95038,
    x2: 15.593,
    y2: 19.0636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0771EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15AAFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveYourResults);
export default __webpack_public_path__ + "static/media/ActiveYourResults.027c6080579a3b0c93c2f6a67836e225.svg";
export { ForwardRef as ReactComponent };